import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTimeSecondToMinute'
})
export class FormatTimeSecondToMinutePipe implements PipeTransform {

  transform(value: number): number {
    return Math.round(value / 60);
  }

}
